module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/dba_blue_logo-5d6016cec8d0d5f2b970cae63a47a186.png";